<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess" >
          <div class="spacer">Jenis Pengguna * :</div>
          <br>
        <w-radios v-model="form.lkp_jenis_pengguna_id"  @input="getCapaian()" :items="jenis_pengguna" inline
          />
        <br><br>
         <z-select 
          outline
          label="Kategori Pengguna *"  
          v-model="form.peranan"
          :items="peran"
          :validators="[validators.required]"
          v-if="(form.role_id=='' && form.peranan == 0) || (form.role_id=='' )"
        />
         <br>
         <template class="mt3" v-if="form.peranan==4 ||  form.role_id.includes(4)">
            <div class="spacer">Kebenaran Akses * :</div>
            <br>
               <w-checkboxes label="Kebenaran Akses *" v-model="form.permission_id" :items="list_permissions" :validators="[validators.required]" inline></w-checkboxes>
            <br>
         </template>
         <w-input
           outline
           label="Nama Penuh *"
           class="mt3"
           type="text"
           placeholder="Nama Penuh"
           name="name"
           :disabled="form.lkp_jenis_pengguna_id ==''"
           v-model="form.name"
           :validators="[validators.required]"
         />
         <template v-if="name">
           <div style="color: red">
             {{ name_wujud }}
           </div>
         </template>

         <template v-if="form.lkp_jenis_pengguna_id != 1">
            <br>
            <w-select 
            outline
            label="Warganegara *"  
            v-model="form.warga_negara"
            :items="wargaNegara"
            @input="getJenisPengguna(form)"
            :validators="[validators.required]"
            />
         </template>

         <template v-if="form.warga_negara==2">
            <br>
            <z-select 
               outline
               class="mt3"
               label="Negara *"  
               v-model="form.lkp_negara_id"
               :items="negara"
               :validators="[validators.required]"
            />
            <br>
           <w-input
             outline
             label="No. Pasport *"
             class="mt3"
             type="text"
             placeholder="No. Pasport"
             name="no_id"
             :disabled="form.id!=0||form.peranan ==''"
             v-model="form.no_id"
             :validators="[validators.required]"
           />
         </template>
         <template v-else>
            <br>
           <w-input
             outline
             label="No. Kad Pengenalan *"
             class="mt3"
             placeholder="No. Kad Pengenalan"
             name="no_id"
             type="tel"
             :disabled="form.id!=0||form.peranan ==''"
             v-model="form.no_id"
             @input="acceptTypeNumber(form)"
             :validators="[validators.required, validators.numeric]"
           />
         </template>
         <template v-if="no_id_lebih_12!=''">
            <div style="color: red">
               {{ no_id_lebih_12 }}
            </div>
         </template>
         <br>
         <w-input
           outline
           label="E-mel *"
           class="mt3"
           type="email"
           placeholder="Sila Masukkan E-mel"
           name="email"
           v-model="form.email"
           :disabled="form.lkp_jenis_pengguna_id ==''"
           :validators="[validators.required, validators.email]"
         />
         <template v-if="email_wujud">
               <div style="color: red">
                 {{ email_wujud }}
               </div>
         </template>
         <br>
          <w-flex wrap :gap="2">
               <div class="grow mb4" style="min-width: 200px">
                  <w-input
                     outline
                     label="Nombor Telefon"
                     class="mt3"
                     type="tel"
                     :disabled="form.lkp_jenis_pengguna_id ==''"
                     placeholder="Sila Masukkan Nombor Telefon"
                     name="no_tel"
                     v-model="form.no_tel"
                     :validators="[validators.required, validators.numeric]"
                  />
               </div>
               <!-- <template v-if="form.lkp_jenis_pengguna_id==1"> -->
                  <div class="grow mb4" style="min-width: 200px">
                     <w-input
                        outline
                        label="Nombor Telefon Pejabat (Jika Ada)"
                        class="mt3"
                        type="tel"
                        :disabled="form.lkp_jenis_pengguna_id ==''"
                        placeholder="Sila Masukkan Nombor Telefon Pejabat"
                        name="no_tel_pejabat"
                        v-model="form.no_tel_pejabat"
                     />
                  </div>
               <!-- </template> -->
            </w-flex>
        <br>
        <template v-if="form.lkp_jenis_pengguna_id==1">
        <z-select
          outline
          :items="negeri"
          label="Negeri *"
          @input="getCawangan(2);"
          :disabled="form.lkp_jenis_pengguna_id ==''"
          v-model="form.lkp_negeri_id"
          :validators="[validators.required]"/>
        <div class="spacer"></div>
        <br>
        <z-select
          outline
          :items="cawangan"
          label="Tempat Bertugas"
          :disabled="form.lkp_jenis_pengguna_id ==''"
          @input="getAlamat()"
          v-model="form.lkp_cawangan_id"
          />
        <br>
        </template>
        <w-textarea
          outline
          label="Alamat Surat Menyurat*"
          placeholder="Sila Masukkan Alamat"
          class="mt3"
          name="alamat"
          v-model="form.alamat"
          :disabled="form.lkp_jenis_pengguna_id==null || form.lkp_jenis_pengguna_id ==''"
          type="text-area"
          :validators="[validators.required]"/>
        <!-- Poskod -->
          <div class="mt3" v-if="form.lkp_jenis_pengguna_id == 2">
              <w-input
                outline
                type="tel"
                label="Poskod *"
                placeholder="Sila Masukkan Poskod"
                v-model="form.kode"
                @change="getPoskodUtama()"
                :validators="[validators.required, validators.numeric]"
              />
          </div>

          <div class="mt3" v-else>
              <w-select
                outline
                :items="poskod"
                label="Poskod *"
                v-model="form.lkp_poskod_id"
                @input="getBandarPoskod()"
                :validators="[validators.required]"
                :readonly="form.lkp_jenis_pengguna_id == 1"
              />
          </div>

          <!-- Daerah -->
          <div class="mt3">
              <w-select
                outline
                :items="bandar"
                label="Mukim/Bandar/Pekan *"
                v-model="form.lkp_bandar_id"
                @input="getDaerah(form, 1)"
                :validators="[validators.required]"
                :readonly="form.lkp_jenis_pengguna_id == 1"
              />
          </div>
          <!-- Daerah -->
          <div class="mt3">
              <w-select
                outline
                @input="getBandar(form, 1)"
                label="Daerah *"
                :items="lkp_daerah"
                v-model="form.lkp_daerah_id"
                :validators="[validators.required]"
                :readonly="form.lkp_jenis_pengguna_id == 1"
              />
          </div>

          <!-- Negeri (untuk Jenis 2) -->
          <div class="mt3" v-if="form.lkp_jenis_pengguna_id == 2">
              <w-select
                outline
                label="Negeri *"
                :items="negeri"
                v-model="form.lkp_negeri_id"
                @input="getBandar(1)"
                :validators="[validators.required]"
              />
          </div>
        <template v-if="form.id > 0 && form.peranan==''">
          <br>
          <div class="spacer">Status Pengguna * :</div>
            <w-switch
              :model-value="form.status == 1"
              :label="form.status == 1 ? 'Aktif' : 'Tidak Aktif'"
              @update:model-value="val => form.status = val ? 1 : 2"
            />
          <!-- <template v-if="form.status == 1">
            <w-switch v-model="form.status" label="Aktif" v-if="form.status == 1"/>
          </template>
          <template v-else>
            <w-switch v-model="form.status" label="Tidak Aktif" />
          </template> -->
          <br>
        </template>

        <w-input
         outline
         label="Seq"
         class="mt3"
         type="text"
         placeholder="Sila Masukkan Seq"
         name="seq"
         v-model="form.dir"
         :disabled="form.lkp_jenis_pengguna_id==null || form.lkp_jenis_pengguna_id ==''"
            />
            <br>
        
        <template v-if="form.peranan==7 || form.peranan==8 || form.role_id.includes(7) || form.role_id.includes(8)">
          <br>
          <w-select
                outline
                label="Diselia oleh Negeri *"
                :items="negeri"
                v-model="form.lkp_diselia_negeri_id"
                :validators="[validators.required]"
              />
              <br>
         <div class="w-flex wrap smd-column" >
            <div class="grow " >
               <w-input
                outline
                label="No. Siri Kad"
                class="mt3"
                type="text"
                name="no_siri"
                v-model="form.no_siri"
              />
            </div>
            <div class="mx2"></div>
            <div class="grow " >
               <w-input class="mt4" outline :validators="[validators.required]" label="Tempoh Sah Laku Sehingga *" type="date" v-model="form.tarikh_lantikan" name="tarikh_lantikan" />
            </div>
         </div>
         <div class="mt3">
            <div class="spacer">Kategori Kelulusan * :</div>
            <br>
               <w-checkboxes label="Kategori *" v-model="form.kategori_user" :items="kategori_user" :validators="[validators.required]" inline/>
            <br>
         </div>
            <div class="mt3" v-if="form.id != 0 && form.kategori_user.includes(1)">Muat Naik Sijil MVC * : <a v-if="attahecment_mvc.length > 0" :href="attahecment_mvc[0].url" target="_blank">{{attahecment_mvc[0].name}}</a></div>
            
            <w-input class="mt3" type="file" v-if="(form.role_id.includes(7) || form.peranan==7 ) && form.kategori_user.includes(1)" :preview="false" accept="application/pdf" v-model="files_mvc" outline :validators="[validators.required]">Muat Naik Sijil MVC</w-input>

            <div class="mt3" v-if="form.id != 0 && form.kategori_user.includes(2)">Muat Naik Sijil Lantikan * : <a v-if="attahecment.length > 0" :href="attahecment[0].url" target="_blank">{{attahecment[0].name}}</a></div>

            <w-input class="mt3" type="file" v-if="(form.role_id.includes(7) || form.peranan==7) && form.kategori_user.includes(2)" :preview="false" accept="application/pdf" v-model="files" outline :validators="[validators.required]">Muat Naik Sijil Lantikan</w-input>
            
        </template>
        <br>
        <w-tooltip right align-bottom color="white" bg-color="blue">
          <template #activator="{ on }">
              <span v-on="on">
                <div class="spacer"></div>
                <w-input
                  outline
                  label="Sila Masukkan Kata Laluan (Kosongkan untuk tidak mengubah Kata Laluan) *"
                  class="mt3"
                  placeholder="Sila Masukkan Kata Laluan"
                  :type="isPassword ? 'password' : 'text'"
                  :inner-icon-right="
                    isPassword ? 'fal fa-eye-slash' : 'fal fa-eye'
                  "
                  @click:inner-icon-right="isPassword = !isPassword"
                  name="password"
                  v-model="form.password"
                />
              </span>
          </template>
        Medan Ini Wajib , minimum 8 aksara
      </w-tooltip>
      <template v-if="form.peranan=='' && form.id > 0">
         <template v-if="$zutil.anyRole(['1'])">
            <!-- <w-select
               label="Tambah Peranan (Sila pilih satu atau lebih) *"
               v-model="form.role_id"
               :items="peran_admin"
               multiple
               outline
               return-object>
            </w-select> -->
            <div class="title4 mt8 mb2"><b>Tambah Peranan (Sila pilih satu atau lebih) *</b></div>
            <w-checkboxes 
                  v-model="form.role_id"
                  :items="peran_admin" class="checkbox-grid w-checkboxes">
               </w-checkboxes>
         </template>
         <template v-else-if="$zutil.anyRole(['4'])">
            <!-- <w-select
               label="Tambah Peranan (Sila pilih satu atau lebih) *"
               v-model="form.role_id"
               :items="peran_kerajaan"
               multiple
               outline
               return-object>
            </w-select> -->
            <div class="title4 mt8 mb2">Tambah Peranan (Sila pilih satu atau lebih) *</div>
            <w-flex class="align-center">
            <w-checkboxes
                  class="mt3"
                  v-model="form.role_id"
                  :items="peran_sttp">
               </w-checkboxes>
            </w-flex>
         </template>
         <!-- <template v-else-if="$zutil.anyRole(['4']) && $page.props.auth.user.lkp_jenis_pengguna_id ==2">
            <w-select
               label="Tambah Peranan (Sila pilih satu atau lebih) *"
               v-model="form.role_id"
               :items="peran_swasta"
               multiple
               outline
               return-object>
            </w-select>
            <div class="title4 mt8 mb2">Tambah Peranan (Sila pilih satu atau lebih) *</div>
            <w-checkboxes
                  class="mt3"
                  v-model="form.role_id"
                  :items="peran_swasta">
               </w-checkboxes>
         </template> -->
      </template>


        <w-flex class="mt3" wrap align-center justify-space-between>
          <div>
            <w-flex class="mt3" wrap align-center >
              <w-button bg-color="grey-light5--bg" @click="tutup">TUTUP</w-button>&nbsp;
            </w-flex>
          </div>
          <div></div>
          <div>
            <template v-if="form.peranan!='' && form.id > 0">
               <w-button class="fs-2" bg-color="success-dark1" dark tile @click="sahkan(form)">
                 <w-icon xs class="mr2">fal fa-check</w-icon> SAHKAN
               </w-button>
               <w-button class="fs-2" bg-color="error-dark1" dark tile @click="tolak(form)">
                 <w-icon xs class="mr2">fal fa-times</w-icon> TOLAK
               </w-button>
            </template>
            <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
            </w-button>
          </div>
        </w-flex>
      </w-form>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_negara : [Array, Object],
    d_negeri: [Array, Object],
    d_jenis_pengguna : [Array, Object],
    d_peran : [Array, Object],
    d_cawangan : [Array, Object],
    d_bandar : [Array, Object],
    d_poskod : [Array, Object],
    d_peran_admin : [Array, Object],
  },
  data() {
    return {
      resourceurl: 'administration.user',
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Pentadbiran', route: '/administration' },
        { label: 'Pengguna', route: '/administration/user' },
      ],
      title : 'Tambah Baka Jantan',
      form : this.d_form,
      negara : this.d_negara,
      negeri : this.d_negeri,
      jenis_pengguna : this.d_jenis_pengguna,
      peran : this.d_peran,
      cawangan: this.d_cawangan,
      bandar: this.d_bandar,
      poskod: this.d_poskod,
      peran_admin: this.d_peran_admin,

      no_id_lebih_12: null,
      email_wujud: '',
      name_wujud:'',
      warga_negara_id: '',

      files_mvc: [],
      files: [],
      attahecment_mvc: [],
      attahecment: [],
      lkp_daerah: [],
      wargaNegara :[
                  { value: 1, label: 'WARGANEGARA' },
                  { value: 2, label: 'BUKAN WARGANEGARA' },
               ],
      peran_kerajaan: [
               { value: 5, label: 'Pengurus Ladang' },
               { value: 9, label: 'Juruteknik Pembiakan Berbantu (AI)' },
               { value: 10, label: 'Juruteknik Pembiakan Berbantu (ET)' },
            ],
      peran_swasta: [
               { value: 2, label: 'Penternak' },
               { value: 7, label: 'Jurusuntik Pembiakan Berbantu (AI)' },
               { value: 8, label: 'Jurusuntik Pembiakan Berbantu (ET)' },
            ],
      peran_sttp: [
                // { value: 2, label: 'Penternak' },
                // { value: 5, label: 'Pengurus Ladang' },
                // { value: 7, label: 'Jurusuntik Pembiakan Berbantu (AI)' },
                // { value: 8, label: 'Jurusuntik Pembiakan Berbantu (ET)' },
                // { value: 9, label: 'Juruteknik Pembiakan Berbantu (AI)' },
                // { value: 10, label: 'Juruteknik Pembiakan Berbantu (ET)' },
      ],
      list_permissions:[
              {value: 3, label: "Penyelaras"},
              {value: 4, label: "Pegawai"},
            ],
      kategori_user: [{value: 1, label: 'MVC' }, { value: 2, label: 'Surat Lantikan' }]
      
      
    }
  },
  methods: {
    tutup(){
      this.$inertia.visit(window.route('administration.user.index'));
    },
    acceptTypeNumber(form) {
        var value = form.no_id;
        var stringValue = value.toString();
        if (stringValue.length > 12 && form.lkp_jenis_pengguna_id==1) {
           this.no_id_lebih_12 = "No. Kad Pengenalan ialah terdiri dari 12 angka";
        }else if(stringValue.length > 12 &&form.warga_negara==1){
            this.no_id_lebih_12 = "No. Kad Pengenalan ialah terdiri dari 12 angka";
        }else{
            this.no_id_lebih_12 = null;
        }
    },
    getJenisPengguna(){
      if (this.form.id ==0) {
         if(this.form.warga_negara==2){
            this.no_id_lebih_12 = null;
            this.warga_negara_id = 2;
            this.form.no_id='';
         }else{
            this.form.no_id='';
            this.warga_negara_id = 1;
         }
      }

    },
    getAttahecment(item)
    {
      if(this.form.id){
        this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\SijilMvc'}).then(res => {
          this.attahecment_mvc = res
          // this.slides = [];
         // for (var b in this.attahecment) {
         //    this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
         // }
        })
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\SijilLantikan'}).then(res => {
          this.attahecment = res
        })
      }
    },
    getCawangan(id){
        if(id==2){
           this.form.lkp_bandar_id = '';
           this.form.lkp_poskod_id = '';
           this.form.lkp_cawangan_id = '';
           this.form.alamat = '';
        }
        this.$zcomm.get(this.api_service + 'lookup/cawangan/'+this.form.lkp_negeri_id, {}).then(res => {
          this.cawangan = res
          this.getBandar();
          this.getPoskodNegri(1);
        })
     },

     getPoskodNegri(id){
       this.$zcomm.get(this.api_service + 'lookup/poskod_negeri/'+this.form.lkp_negeri_id, {}).then(res => {
         this.poskod = res
       })
     },
     getCapaianSttp(id){
       this.$zcomm.get(this.api_service + 'lookup/capaian-sttp', {}).then(res => {
         this.peran_sttp = res
       })
     },
    
    getNegara(){
        this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
          this.negara = res
        })
    },
    getDaerah(id){
      this.$zcomm.get(this.api_service + 'lookup/daerah/'+this.form.lkp_negeri_id, {}).then(r => {
         this.lkp_daerah = r
      })
   },


    getNegeri(){
        this.form.lkp_bandar_id = '';
        this.form.lkp_poskod_id = '';
        this.form.lkp_cawangan_id = '';
        this.form.lkp_negeri_id = '';
        this.form.alamat = '';
        this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
          this.negeri = res
          this.getBandar();
          
        })
    },

    getPoskodUtama(){
       this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form.kode, {}).then(res => {
            if(res.lkp_bandar_id){
              this.$zcomm.get(this.api_service + 'lookup/poskod/'+res.lkp_bandar_id, {}).then(r => {
                this.poskod = r
                this.form.lkp_poskod_id = res.lkp_poskod_id
              })
              this.$zcomm.get(this.api_service + 'lookup/bandar/'+res.lkp_daerah_id, {}).then(r => {
                this.bandar = r
                this.form.lkp_bandar_id = res.lkp_bandar_id
              })
              this.$zcomm.get(this.api_service + 'lookup/daerah/'+res.lkp_negeri_id, {}).then(r => {
                this.lkp_daerah = r
                this.form.lkp_daerah_id = res.lkp_daerah_id
              })
              this.form.lkp_negeri_id = res.lkp_negeri_id
            }
        })
      // this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form.kode, {}).then(res => {
      //   // this.form.p = res.p
      //   this.form.lkp_negeri_id = res.lkp_negeri_id
      //   this.form.lkp_bandar_id = res.lkp_bandar_id
      //   this.form.lkp_poskod_id = res.lkp_poskod_id
      //   this.getPoskod(0)
      //   this.getBandar(0)
      // })
    },

    getBandar(id){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form.lkp_daerah_id, {}).then(res => {
           this.bandar = res
        })
    },

    getBandarPoskod(id){
        // this.form.lkp_bandar_id == '';
        this.$zcomm.get(this.api_service + 'lookup/bandar_poskod/'+this.form.lkp_poskod_id, {}).then(res => {
           this.bandar = res
        })
    },

    getPoskod(id){
        this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form.lkp_bandar_id, {}).then(res => {
          this.poskod = res
        })
    },
    getAlamat(){
      this.$zcomm.get(this.api_service + 'lookup/alamat/'+this.form.lkp_cawangan_id, {}).then(res => {
        this.form.alamat = res.alamat
        this.form.lkp_bandar_id = res.lkp_bandar_id
        this.form.lkp_poskod_id = res.lkp_poskod_id
        this.form.lkp_daerah_id = res.lkp_daerah_id
          this.getBandar(1);
          this.getPoskod()
          this.getDaerah()
        // if (this.alamat.length > 0) {
        //  this.form.alamat = this.alamat.alamat;
        // }
      })
        //this.form.lkp_bandar_id = '';
        //this.form.lkp_poskod_id = '';
        //this.form.alamat = '';
        // this.$zcomm.get(this.api_service + 'lookup/alamat/'+this.form.lkp_cawangan_id, {}).then(res => {
          // this.form.alamat = res.alamat
          // this.form.lkp_bandar_id = res.lkp_bandar_id
          //  this.getPoskod();
          // this.form.lkp_poskod_id = res.lkp_poskod_id
        // })
    },
    
    getCapaian(id){
         if(this.form.lkp_jenis_pengguna_id != null || this.form.lkp_jenis_pengguna_id != ''){
            this.form.peranan = '';
            this.no_id_lebih_12 = null;
            this.form.lkp_bandar_id = '';
            this.form.lkp_poskod_id = '';
            this.form.lkp_cawangan_id = '';
            this.form.lkp_negeri_id = '';
            this.form.lkp_negara_id='';
            this.form.lkp_daerah_id='';
            this.form.kode='';
            this.form.alamat = '';
            // this.form.warga_negara = '';
            this.form.no_siri='';
            this.form.tarikh_lantikan='';
            this.form.role_id='';
            // this.form.no_id='';
            // this.form.email='';
            this.form.dir='';
            // this.form.name='';
            this.form.password='';
         }
        this.$zcomm.get(this.api_service + 'lookup/capaian/'+this.form.lkp_jenis_pengguna_id, {}).then(res => {
          this.peran = res
        })
    },
    onSuccess(){
      if(this.form.role_id && this.form.role_id.map(Number).includes(7)){
        if(this.form.kategori_user.map(Number).includes(1) && this.files_mvc == [] && this.attahecment_mvc.length == 0){
          this.$zutil.notify("Pastikan Sijil MVC telah dimuat naik.", false);
          return
        }
        if(this.form.kategori_user.map(Number).includes(2) && this.files == [] && this.attahecment.length == 0){
          this.$zutil.notify("Pastikan Sijil Surat Lantikan telah dimuat naik.", false);
          return
        }
      }
      if (this.form.id > 0) 
      {
        this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
        .then(res => {
          if (this.files !=[]) {
            this.uploadMvc(res);
            this.uploadLantikan(res);

          }
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          this.$inertia.visit(this.$route('administration.user.index', {}))
        })
      }
      else 
      {
        if (this.form.password!=null||this.form.password!='') {
          this.$zcomm.add(this.resourceurl + '.store', this.form)
                      .then(res => {
                        if (this.files.length > 0) {
                           this.uploadMvc(res);
                          this.uploadLantikan(res);
                        }
                        this.dialog.show = false;
                        this.$inertia.visit(this.$route('administration.user.index', {}))
                      
                      })
                      .catch(err => {
                        if (err.response.data.errors.email == "The email has already been taken.")
                            {
                                 this.$zutil.notify("Email sudah wujud!", false);
                            }
                        if (err.response.data.errors.no_id == "The no id has already been taken.")
                            {
                                this.$zutil.notify("No. Kad Pengenalan sudah wujud!", false);
                            }
                        if (err.response.data.errors.password == "The password field is required.")
                            {
                                this.$zutil.notify("Password takboleh kosong!", false);
                            }

                      })
                      .finally(() => {
                          this.dialog.loading = false;
                          // this.dialog.show = false
                          // this.$inertia.reload();

                        // $('#' + this.resourceurl).modal('hide')
                      });
        }else{
          this.notify("Password takboleh kosong", 0);
        }
      }
    },
    uploadImg(item) 
    {  
      let formData = new FormData();
      for (var b in this.files) 
      {
           formData.append("files["+b+"]", this.files[b].file);
      }
      formData.append("model",'\\App\\Model\\SijilUser');
      formData.append("model_id", item.id);
      this.$zcomm.post('attahecment.upload', formData)
         .then((res) => {
            // this.getAttahecment();
         })
         .catch((err) => {})
         .finally(() => {});
    },
      uploadMvc(item) 
         {  
         let formData = new FormData();
         for (var b in this.files_mvc) 
         {
              formData.append("files["+b+"]", this.files_mvc[b].file);
         }
         formData.append("model",'\\App\\Model\\SijilMvc');
         formData.append("model_id", item.id);
         this.$zcomm.post('attahecment.upload', formData)
            .then((res) => {
               // this.getAttahecment();
            })
            .catch((err) => {})
            .finally(() => {});
      },

      uploadLantikan(item) 
      {  
         let formData = new FormData();
         for (var b in this.files) 
         {
              formData.append("files["+b+"]", this.files[b].file);
         }
         formData.append("model",'\\App\\Model\\SijilLantikan');
         formData.append("model_id", item.id);
         this.$zcomm.post('attahecment.upload', formData)
            .then((res) => {
               // this.getAttahecment();
            })
            .catch((err) => {})
            .finally(() => {});
      },
    sahkan(item) {
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(item.id > 0){
          item.sahkan = 1;
          this.$zcomm.update(this.resourceurl + '.update', item.id, item)
              .then(res => {
                  this.dialog.show = false;
                  this.$inertia.reload();
                  this.$inertia.visit(this.$route('administration.user.index', {}))
              })
              .catch(err => {
                  this.dialog.show = false
                  this.$inertia.reload();
                  this.$inertia.visit(this.$route('administration.user.index', {}))
              })
              .finally(() => {
                  this.dialog.show = false
                  this.$inertia.reload();
                  this.$inertia.visit(this.$route('administration.user.index', {}))
              });
              this.dialog.loading = false;
                  this.dialog.show = false
                  this.$inertia.reload();
                  this.$inertia.visit(this.$route('administration.user.index', {}))
          }
        }else{ this.loading = false;}

        }) 
      },
      
      tolak(item) {
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(item.id > 0){
          item.tolak = 1;
          this.$zcomm.update(this.resourceurl + '.update', item.id, item)
              .then(res => {
                console.log(res);
                  this.dialog.show = false
                  this.$inertia.reload();
                  this.$inertia.visit(this.$route('administration.user.index', {}))
              })
              .catch(err => {
                  this.dialog.show = false
                  this.$inertia.reload();
                  this.$inertia.visit(this.$route('administration.user.index', {}))

              })
              .finally(() => {
                  this.dialog.show = false
                  this.$inertia.reload();
                  this.$inertia.visit(this.$route('administration.user.index', {}))
              });
              this.dialog.loading = false;
          }
        }else{ this.loading = false;}

        }) 
      },
    
  
  },

  watch: {

  },
  mounted() {
    if(this.form.id > 0)
    {
      this.title = 'Kemaskini Pengguna'
      this.getAttahecment();
      this.getDaerah()
      this.getCapaianSttp()
    }
    else
    {
      this.title = 'Tambah Pengguna'
    }

    
  }
    
}
</script>
<style>
.w-checkboxes,
.w-checkboxes__container,
.checkbox-grid {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    column-gap: 20px !important;
    row-gap:100px !important;
    line-height: 1.5 !important;
}
.w-checkboxes {
    padding-left: 20px !important;   /* boleh tukar ke 20px / 40px */
}
/* Pastikan item tidak memenuhi 100% */
.w-checkboxes__item {
    width: auto !important;
    line-height: 1.5 !important;
    white-space: normal !important;
}
</style>